import React from "react";
import ParticipacionSeleccionTorneo from "./ParticipacionSeleccionTorneo.js";
import styles from "./Selecciones.module.css";

const DatosSeleccionTorneo = (props) => {
  const pais = props.pais;
  const categoria = props.categoria;
  const torneo = props.torneo;

  return (
    <React.Fragment>
      {torneo && (
        <div className={`${styles.cuadroDatos}`}>
          <span className={`${styles.tituloCuadroDatos}`}>
            {torneo && torneo.descripcion}
          </span>
          {torneo.hijo && (
            <ParticipacionSeleccionTorneo 
            pais={pais} 
            categoria={categoria} 
            torneo={torneo.hijo}
            titulo={torneo.hijo.descripcion}
          />
          )}
          <ParticipacionSeleccionTorneo
            pais={pais} 
            categoria={categoria} 
            torneo={torneo}
            titulo={torneo.hijo && "Torneo"}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default DatosSeleccionTorneo;
